define ['./text_display.css'], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./text_display.jade")
    scope: {field: "=", mode: "@", index: "="}



// WEBPACK FOOTER //
// ./directives/freeforms/text_display/text_display.coffee